import axios from "../api/axios";
import config from '../config/configJS';

function SendData(intent, data) {
  var promise = new Promise(function (resolve, reject) {
    axios
      .post(config.endPoint + "/api/millai/prompt", 
        JSON.stringify({ Intent: intent, data: data }), {       
        headers: {
          'Accept': 'application/json',
           'Content-Type': 'application/json'
        },
        withCredentials: true,
      })
      .then((response) => {  
        let obj = JSON.parse(response.data);
        resolve(obj);
      })
      .catch((error) => {
        console.log(error);
        reject(error);
      });
  });
  return promise;
}

export function getFavouriteQuestions(intent, lang) {
  return new Promise((resolve, reject) => {
    SendData(
      'GetUserQuestions',
      {
        Intent: intent,
        Language: lang,
      }
    )
      .then((data) => {
        resolve(data.Data); 
      })
      .catch((err) => {
        console.log(err);
        reject(err); 
      });
  });
}

export function saveFavouriteQuestion(intent, question, lang, docsEnvId) {
  if (intent == 'PromtEmbeddings') {
    return new Promise((resolve, reject) => {
      SendData('SetUserQuestions', { 
        Intent: intent, 
        Question: question, 
        Language: lang,
        DocsEnvId: docsEnvId 
      })
        .then((data) => {
          resolve(data);
        })
        .catch((err) => {
          console.log(err);
          reject(err);
        });   
    });
  } else {
    return new Promise((resolve, reject) => {
      SendData('SetUserQuestions', { 
        Intent: intent, 
        Question: question, 
        Language: lang
      })
        .then((data) => {
          resolve(data);
        })
        .catch((err) => {
          console.log(err);
          reject(err);
        });   
    });
  } 
}

export function deleteFavouriteQuestion(id) {
  return new Promise((resolve, reject) => {
    SendData('RemoveUserQuestions', { Id: id })
      .then((data) => {
        resolve(true);
      })
      .catch((err) => {
        console.log(err);
        reject(err);
      });
  });
}

export function saveQuestionRating(msg, rating){
  var promise = new Promise(function (resolve, reject) {
    axios
      .post(config.endPoint + "/api/millai/prompt", 
        JSON.stringify({ 
          Intent: "SaveQuestionRating", 
          data: {
            "MessageID": msg,
            "Rating": rating
          } 
          }), {       
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          },
          withCredentials: true,
      })
      .then((response) => {       
        let obj = JSON.parse(response.data);
        resolve(obj);
      })
      .catch((error) => {
        console.log(error);
        reject(error);
      });
  });
  return promise;
}

export function saveQuestionReview(msg, review){
  var promise = new Promise(function (resolve, reject) {
    axios
      .post(config.endPoint + "/api/millai/prompt", 
        JSON.stringify({ 
          Intent: "SaveQuestionReview", 
          data: {
            "MessageID": msg,
            "Review": review
          } 
          }), {       
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          },
          withCredentials: true,
      })
      .then((response) => {       
        let obj = JSON.parse(response.data);
        resolve(obj);
      })
      .catch((error) => {
        console.log(error);
        reject(error);
      });
  });
  return promise;
}

export function sendMessageToBE(selectedIntent, messageHistory, formData, id, docsEnvId, tabItemId) {
  return new Promise((resolve, reject) => {

    const newMessage = messageHistory
        .map((item) => {
      if (item.intent === selectedIntent) {
        return {
          ...item,
          chat: [...item.chat, { id: id, Type: 0, Role: 'user', Message: formData }],
        };
      }
      return item;
    });

    const { chat } = newMessage.find((item) => item.intent === selectedIntent);
    const Messages = chat
        .filter(item => item.Type != 4);
    var messagesToSend = Messages.slice(-12);

    // CHECK FOR RESET
    const resetIndex = messagesToSend.findIndex(message => message.Type === 5);
    if (resetIndex !== -1) {
      messagesToSend.splice(0, resetIndex + 1);
    }

      SendData(
        selectedIntent,
        {
          'DocsEnvId': docsEnvId,
          "TabItemId": tabItemId,
          'Messages': messagesToSend,
        },  
      )
      .then((data) => {
        if (data.Data.Messages[0].Type === 0) {
          resolve({
            Role: 'assistant',
            Type: data.Data.Messages[0].Type,
            Message: data.Data.Messages[0].Message,
            GeneratedSQL: data.Data.Messages[0].GeneratedSQL,
            Status: data.Status
          });
        } else if (data.Data.Messages[0].Type === 1) {
          resolve({
            Role: 'assistant',
            Type: data.Data.Messages[0].Type,
            Message: data.Data.Messages[0].Table,
            SystemMessage: data.Data.Messages[0].SystemMessage,
            GeneratedSQL: data.Data.Messages[0].GeneratedSQL,
            Status: data.Status
          });
        } else if (data.Data.Messages[0].Type === 2) {
          resolve({
            Role: 'assistant',
            Type: data.Data.Messages[0].Type,
            Message: data.Data.Messages[0].Message,
            Status: data.Status
          });
        } else if (data.Data.Messages[0].Type === 3) {
          console.log(data.Data.Type);

          resolve({           
            Role: 'assistant',
            Type: data.Data.Messages[0].Type,
            EnvironmentType: data.Data.Type,
            Message: data.Data.Messages[0].Message,
            MessageID: data.Data.Messages[0].MessageID,
            Metadata: data.Data.Messages[0].UserDocsMessage,
            ExtractionTaskId: data.Data.Messages[0].ExtractionTaskId,
            Status: data.Status
          });
        }
      })
      .catch((err) => {
        reject(err);
      });   
  });
}
